export default {
  jurassic: {
    label: 'Jurassic',
    characters: ['spino', 'stego', 'rex', 'terra'],
    backgroundImage: 'jurassic-bkg.png'
  },
  fairytale: {
    label: 'Fairytale',
    characters: ['princess', 'prince', 'fairy', 'jester'],
    backgroundImage: 'fairytale-bkg.png'
  },
};

